import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-Organisation', ['identityForm', 'saveButton']);
